import mitt from "mitt";
var __defProp$2 = Object.defineProperty;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$2 = (obj, key, value) => {
  __defNormalProp$2(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class PageManager {
  constructor() {
    __publicField$2(this, "mountTarget");
    __publicField$2(this, "origin", getLocationOrigin());
    __publicField$2(this, "routes", {});
  }
  mount(target) {
    this.mountTarget = target;
  }
  register(path, handler) {
    this.routes[path] = handler;
  }
  open(applink, options) {
    const _options = options;
    if (this.mountTarget && this.routes[applink.target]) {
      this.routes[applink.target](this.mountTarget, applink, _options);
    } else {
      const props = _options.props || {};
      const { host, protocol, port } = new URL(this.origin);
      applink.host = host;
      applink.port = port;
      applink.protocol = protocol;
      Object.keys(props).forEach((key) => {
        if (typeof props[key] === "number" || typeof props[key] === "string") {
          applink.searchParams.set(key, "".concat(props[key]));
        } else if (Array.isArray(props[key])) {
          applink.searchParams.set(key, props[key].map(String).join(","));
        } else if (typeof props[key] === "boolean") {
          applink.searchParams.set(key, props[key] ? "true" : "false");
        }
      });
      window.open(applink.href, _options.target);
    }
  }
}
const EventName = {
  open: "onOpen",
  close: "onClose",
  complete: "onComplete",
  error: "onError"
};
const IFRAME_ID_PREFIX = "buy-buy-application-modal-next";
const LOADING_TIMEOUT = 30 * 1e3;
const LOADING_RETRY = 2;
var __defProp$1$1 = Object.defineProperty;
var __defNormalProp$1$1 = (obj, key, value) => key in obj ? __defProp$1$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1$1 = (obj, key, value) => {
  __defNormalProp$1$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class Views {
  constructor(options) {
    __publicField$1$1(this, "iframe", null);
    __publicField$1$1(this, "content", null);
    __publicField$1$1(this, "uuid");
    __publicField$1$1(this, "lifecycle");
    __publicField$1$1(this, "path");
    __publicField$1$1(this, "zIndex", 9999);
    __publicField$1$1(this, "mask", true);
    __publicField$1$1(this, "loaded", false);
    __publicField$1$1(this, "componentModalClose");
    __publicField$1$1(this, "_evenetListener");
    __publicField$1$1(this, "_listenerExit", (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        this.destroy();
      }
    });
    __publicField$1$1(this, "retryCount");
    __publicField$1$1(this, "timeout");
    __publicField$1$1(this, "timeoutControl");
    __publicField$1$1(this, "_buildMask", () => {
      const mask = document.createElement("div");
      mask.setAttribute("class", "gda-modal-mask");
      mask.setAttribute(
        "style",
        "position: fixed;left: 0;top:0; height:100%; width:100%;z-index:".concat(this.zIndex - 2, ";display:flex;justify-content: center;align-items:center;background-color: rgba(0,0,0,.6);")
      );
      window.addEventListener("keydown", this._listenerExit, true);
      return mask;
    });
    var _a;
    this.uuid = "".concat(IFRAME_ID_PREFIX, "_").concat((/* @__PURE__ */ new Date()).getTime());
    this.lifecycle = options.lifecycle;
    this.path = options.path;
    this.retryCount = options.retryCount !== void 0 ? options.retryCount : LOADING_RETRY;
    this.timeout = options.timeout !== void 0 ? options.timeout : LOADING_TIMEOUT;
    this.zIndex = (_a = options.zIndex) != null ? _a : this.zIndex;
    this.mask = options.mask !== void 0 ? options.mask : this.mask;
    return this;
  }
  _buildContent() {
    const content = document.createElement("div");
    content.id = "".concat(this.uuid, "_content");
    const displayedStyle = "height:100vh;width:100vw;border:none;position:fixed;top:0;left:0;z-index:".concat(this.zIndex);
    content.setAttribute("style", displayedStyle);
    this.content = content;
    return content;
  }
  _buildLoading() {
    const span = document.createElement("span");
    span.setAttribute("class", "gda-spin-dot gda-spin-dot-spin");
    for (let i = 0; i < 4; i += 1) {
      const dot = document.createElement("i");
      dot.setAttribute("class", "gda-spin-dot-item");
      dot.setAttribute("style", "background-color:#fff");
      span.append(dot);
    }
    const loading = document.createElement("div");
    loading.setAttribute("class", "gda-spin gda-spin-spinning");
    loading.append(span);
    return loading;
  }
  _buildIframe() {
    this.destroy();
    const iframe = document.createElement("iframe");
    const iframeStyle = "height:100%;width:100%;border:none;background-color:transparent;position:relative;z-index:".concat(this.zIndex - 1);
    iframe.setAttribute("allowtransparency", "true");
    iframe.src = this.path.path;
    iframe.id = this.uuid;
    iframe.setAttribute("style", "".concat(iframeStyle, ";visibility:hidden"));
    const content = this._buildContent();
    if (this.mask) {
      const mask = this._buildMask();
      const loading = this._buildLoading();
      mask.append(loading);
      content.append(mask);
    }
    content.append(iframe);
    document.body.append(content);
    this._buildIframeListener(iframe, iframeStyle);
    return iframe;
  }
  _buildIframeListener(iframe, iframeStyle) {
    iframe.addEventListener("error", () => {
      this.destroy();
    });
    this._evenetListener = async (event) => {
      var _a;
      const data = event.data;
      if (!data)
        return;
      const method = data.method;
      const type = data.type;
      const dataSource = data.data;
      if (type !== "buy-application-modal-type" && type !== "applink-modal-type") {
        return;
      }
      if (method === EventName.open) {
        iframe.setAttribute("style", iframeStyle);
        if (!this.mask) {
          (_a = this.content) == null ? void 0 : _a.append(this._buildMask());
        }
        this.loaded = true;
        clearTimeout(this.timeout);
        await this._callLifecycle(EventName.open, dataSource);
      } else if (method === EventName.close) {
        await this._callLifecycle(EventName.close, dataSource);
        this.destroy();
      } else {
        await this._callLifecycle(method, dataSource);
      }
    };
    window.addEventListener("message", this._evenetListener);
    return iframe;
  }
  /** 超时重试机制 */
  _retryWhileTimeout() {
    if (this.timeoutControl)
      clearTimeout(this.timeoutControl);
    this.timeoutControl = setTimeout(() => {
      var _a, _b, _c;
      if (!this.loaded) {
        if (this.retryCount > 0) {
          console.log("第".concat(LOADING_RETRY - this.retryCount + 1, "次请求重试"), this.loaded);
          this.retryCount -= 1;
          if (this.iframe) {
            this.iframe.src = this.path.path;
          }
          this._retryWhileTimeout();
        } else {
          ((_a = this.lifecycle) == null ? void 0 : _a.onError) && typeof ((_b = this.lifecycle) == null ? void 0 : _b.onError) === "function" && ((_c = this.lifecycle) == null ? void 0 : _c.onError());
          this.destroy();
          if ((window == null ? void 0 : window.GD_SLS_RUM) && (window == null ? void 0 : window.GD_SLS_RUM.addError)) {
            window == null ? void 0 : window.GD_SLS_RUM.addError(new Error("商业化弹窗错误"));
          }
        }
      }
    }, this.timeout);
  }
  async _callLifecycle(method, data) {
    if (this.lifecycle && this.lifecycle[method] && typeof this.lifecycle[method] === "function") {
      this.lifecycle[method](data);
    }
  }
  open() {
    this.iframe = this._buildIframe();
    this._retryWhileTimeout();
  }
  destroy() {
    const elements = document.querySelectorAll('[id^="'.concat(IFRAME_ID_PREFIX, '"]'));
    elements.forEach((element) => {
      element.remove();
    });
    this.iframe = null;
    this.loaded = false;
    if (this.timeoutControl) {
      window.clearTimeout(this.timeoutControl);
    }
    if (this.componentModalClose && typeof this.componentModalClose === "function") {
      this.componentModalClose();
    }
    if (this._evenetListener) {
      window.removeEventListener("message", this._evenetListener);
      this._evenetListener = void 0;
    }
    window.removeEventListener("keydown", this._listenerExit, true);
  }
}
var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class PopupManager {
  constructor() {
    __publicField$1(this, "js");
    __publicField$1(this, "iframe");
    __publicField$1(this, "window");
    this.js = new JSPopupOpener();
    this.iframe = new IFramePopupOpener();
    this.window = new WindowPopupOpener();
  }
  open(applink, options) {
    if (typeof window === "undefined") {
      return new SimpleAppLinkPopupItem();
    }
    return this[options.mode || "iframe"].open(applink, options);
  }
  setOrigin(origin) {
    this.iframe.origin = origin;
  }
}
class JSPopupOpener {
  constructor() {
    __publicField$1(this, "handlerMap", /* @__PURE__ */ new Map());
  }
  register(popupName, handler) {
    this.handlerMap.set(popupName, handler);
  }
  open(applink, options) {
    const handler = this.handlerMap.get(applink.target);
    if (handler) {
      return handler(applink, options);
    }
    throw new Error("不支持的弹窗 ".concat(applink.target));
  }
}
class IFramePopupOpener {
  constructor() {
    __publicField$1(this, "origin", getLocationOrigin());
    __publicField$1(this, "events", EventName);
  }
  open(applink, _options) {
    const modal = new SimpleAppLinkPopupItem();
    const props = _options.props || {};
    const { host, protocol, port } = new URL(this.origin);
    applink.host = host;
    applink.port = port;
    applink.protocol = protocol;
    Object.keys(props).forEach((key) => {
      if (typeof props[key] === "number" || typeof props[key] === "string") {
        applink.searchParams.set(key, "".concat(props[key]));
      } else if (Array.isArray(props[key])) {
        applink.searchParams.set(key, props[key].map(String).join(","));
      } else if (typeof props[key] === "boolean") {
        applink.searchParams.set(key, props[key] ? "true" : "false");
      }
    });
    let iframeView = new Views({
      lifecycle: {},
      path: { path: applink.toString() },
      mask: false
      // retryCount: 0,
    });
    if (typeof window !== "undefined") {
      const handler = (event) => {
        if (event.origin !== this.origin)
          return;
        if (event.data.type === "applink" && event.data.action === "popup") {
          const data = event.data.params[0];
          modal.emit(String(event.data.event), data);
        }
      };
      window.addEventListener("message", handler);
      modal.on("close", () => {
        window.removeEventListener("message", handler);
        iframeView == null ? void 0 : iframeView.destroy();
        iframeView = null;
      });
    }
    iframeView.open();
    return modal;
  }
}
class WindowPopupOpener {
  open(_applink, _options) {
    throw new Error("Not implement");
  }
}
function definePopupHandler(handler) {
  return (...args) => {
    const applinkPopupItem = new SimpleAppLinkPopupItem();
    handler(applinkPopupItem, ...args);
    return applinkPopupItem;
  };
}
class SimpleAppLinkPopupItem {
  constructor() {
    __publicField$1(this, "emitter", mitt());
    __publicField$1(this, "windowProxy");
  }
  emit(eventName, event) {
    this.emitter.emit(eventName, event);
  }
  on(eventName, listener) {
    this.emitter.on(eventName, listener);
  }
  off(eventName, listener) {
    this.emitter.off(eventName, listener);
  }
  once(eventName, listener) {
    const wrap = (event) => {
      this.emitter.off(eventName, wrap);
      return listener(event);
    };
    this.emitter.on(eventName, wrap);
  }
}
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
function getLocationOrigin() {
  if (typeof window !== "undefined")
    return location.origin;
  else
    return "https://www.gaoding.com";
}
class AppLinkResolved extends URL {
  constructor(url) {
    if (url.startsWith("/")) {
      url = "".concat(getLocationOrigin()).concat(url);
    }
    super(url);
    __publicField(this, "action");
    __publicField(this, "target");
    const paths = this.pathname.split("/");
    if (paths[1] !== "applink") {
      throw new Error("".concat(url, " 不符合 applink 规范"));
    }
    this.action = paths[2];
    this.target = paths[3];
  }
}
class AppLink {
  constructor() {
    __publicField(this, "popup");
    __publicField(this, "page");
    this.popup = new PopupManager();
    this.page = new PageManager();
  }
  open(url, options) {
    const resolved = this.resolve(url);
    if (resolved.action === "page") {
      return this.page.open(resolved, options);
    } else if (resolved.action === "popup") {
      return this.popup.open(resolved, options);
    } else {
      throw new Error("".concat(url, " 不符合 applink 规范 action 不存在"));
    }
  }
  /**
   * 解析 applink
   */
  resolve(url) {
    return new AppLinkResolved(url);
  }
}
const version = "0.0.7";
export {
  AppLink,
  AppLinkResolved,
  IFramePopupOpener,
  JSPopupOpener,
  PopupManager,
  SimpleAppLinkPopupItem,
  WindowPopupOpener,
  definePopupHandler,
  getLocationOrigin,
  version
};
